<template>
    <div id="customlightbox">
        <HrrBreadcrumb PMname="信息管理" CMname="用户站点管理" C2Mname="媒体管理" />
        <HrrMainCardLayout>
            <template slot="custom">
                <el-form label-position="right" inline class="lightbox-from" label-width="100px">
                    <el-form-item label="站点名称：">
                        <span>{{siteInfo.siteName}}</span>
                    </el-form-item>
                    <el-form-item label="站点描述：">
                        <span>{{siteInfo.siteDesc}}</span>
                    </el-form-item>
                    <el-form-item label="楼层数：">
                        <span>{{siteInfo.floor}}</span>
                    </el-form-item>
                    <el-form-item label="站点类型：">
                        <span>{{siteInfo.siteType}}</span>
                    </el-form-item>
                    <el-form-item label="地址：">
                        <span>{{siteInfo.siteAddress}}</span>
                    </el-form-item>
                </el-form>
            </template>
        </HrrMainCardLayout>
        <HrrMainLayout>
            <template slot="searh">
                <el-form :inline="true" :model="searchform">
                    <el-form-item>
                        <el-input v-model="keyword" placeholder="关键字">
                            <el-select v-model="selectfield" slot="prepend" placeholder="请选择" class="input-with-select">
                                <el-option label="媒体编号" value="lightBoxCode"></el-option>
                                <el-option label="媒体名称" value="lightBoxName"></el-option>
                                <el-option label="媒体描述" value="lightBoxDesc"></el-option>
                                <el-option label="媒体地址" value="lightBoxAddress"></el-option>
                            </el-select>
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                </el-form>
            </template>
            <template slot="buttons">
                <el-button-group>
                    <el-button type="primary" icon="el-icon-edit" size="small" @click="Addclick" v-if="isHadFun('SiteAddLightBox')">新增</el-button>
                    <el-button type="primary" icon="el-icon-edit-outline" size="small" @click="editclick" v-if="isHadFun('SiteModifyLightBox')">编辑</el-button>
                    <el-button type="primary" icon="el-icon-delete" size="small" @click="delclick" v-if="isHadFun('SiteDelLightBox')">删除</el-button>
                    <el-button type="primary" icon="fa fa-check-square-o" size="small" v-if="false">审核</el-button>
                    <el-button type="info" icon="fa fa-undo" size="small" @click="returnMForm()">返 回</el-button>
                </el-button-group>
            </template>
            <template slot="table">
                <el-table :data="tableData" ref="Opentable" @cell-click="cellclick" @selection-change="selectionchange" border stripe style="width: 100%" v-loading="loading" :cell-style="cellStyle">
                    <el-table-column type="selection" width="55" fixed="left">
                    </el-table-column>
                    <el-table-column prop="lightBoxCode" label="媒体编号" width="140" fixed="left" sortable>
                    </el-table-column>
                    <el-table-column prop="lightBoxName" label="媒体名称" width="200">
                    </el-table-column>
                    <el-table-column prop="lightBoxDesc" label="媒体描述" width="250">
                    </el-table-column>
                    <el-table-column prop="lightBoxAddress" label="媒体地址" width="260">
                    </el-table-column>
                    <el-table-column prop="siteName" label="所属站点" width="160">
                    </el-table-column>
                    <el-table-column prop="creationDate" label="创建时间" width="200" sortable>
                    </el-table-column>
                    <el-table-column prop="creationBy" label="创建人" width="100">
                    </el-table-column>
                    <el-table-column label="状态" width="70" align="center">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.status?'success':'danger'" disable-transitions>{{scope.row.status?'启用':'禁用'}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="deviceNum" label="使用设备数" width="100" fixed="right">
                    </el-table-column>
                    <el-table-column label="操作" width="220" fixed="right">
                        <template slot-scope="scope">
                            <el-button @click.stop="Rowview(scope.row)" type="text" size="small" v-if="false">查看</el-button>
                            <el-button @click.stop="RowEdit(scope.row)" type="text" size="small" v-if="isHadFun('SiteModifyLightBox')">编辑</el-button>
                            <el-button @click.stop="Rowdelete(scope.row)" type="text" size="small" v-if="isHadFun('SiteDelLightBox')">删除</el-button>
                            <el-button @click.stop="RowDevice(scope.row)" type="text" size="small" v-if="isHadFun('SiteLookDevices')">查看设备</el-button>
                            <el-button @click.stop="RowChange(scope.row)" type="text" size="small" v-if="isHadFun('SiteChangeDevice')">更换设备</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <template slot="Pagination">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchform.pageNum" :page-sizes="[5, 10, 15]" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </template>
        </HrrMainLayout>
        <!--弹窗-->
        <el-dialog title="更换设备" v-model="dialogVisible" :visible.sync="dialogVisible" class="el-dialog-change">
            <el-form :inline="true" :model="deviceform">
                <el-form-item>
                    <el-input v-model="devicekeyword" placeholder="关键字">
                        <el-select v-model="deviceselectfield" slot="prepend" placeholder="请选择" class="input-with-select">
                            <el-option label="设备编号" value="deviceNickCode"></el-option>
                        </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item label="状态：" prop="bindType">
                    <el-select v-model="deviceform.bindType" placeholder="请选择">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="未绑定" value="未绑定"></el-option>
                        <el-option label="已绑定" value="已绑定"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmitDevice">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="devicesData" ref="deviceTable" border stripe style="width: 100%" v-loading="loading">
                <el-table-column prop="deviceNickCode" label="设备编号" width="140" fixed="left" sortable>
                </el-table-column>
                <el-table-column prop="deviceCode" label="自动设备编号" width="140" fixed="left" v-if="isHadFun('deviceCode')">
                </el-table-column>
                <el-table-column prop="deviceName" label="设备名称" width="200">
                </el-table-column>
                <el-table-column prop="bindType" label="设备类型" width="120">
                </el-table-column>
                <el-table-column prop="lightBoxCode" label="所在媒体编号" width="140">
                </el-table-column>
                <el-table-column prop="siteName" label="所属站点" width="150">
                </el-table-column>
                <el-table-column label="状态" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag effect="dark" type="info" disable-transitions v-if="scope.row.status==0">未使用</el-tag>
                        <el-tag effect="dark" type="success" disable-transitions v-if="scope.row.status==1">使用</el-tag>
                        <el-tag effect="dark" type="warning" disable-transitions v-if="scope.row.status==2">维修</el-tag>
                        <el-tag effect="dark" type="danger" disable-transitions v-if="scope.row.status==3">损坏</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="80">
                    <template slot-scope="scope">
                        <el-button @click.stop="RowSetDevcie(scope.row)" type="text" size="small">替换</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @size-change="dhandleSizeChange" @current-change="dhandleCurrentChange" :current-page="deviceform.pageNum" :page-sizes="[5, 10, 15]" layout="total, sizes, prev, pager, next, jumper" :total="devicetotal">
            </el-pagination>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: 'lightbox_info',
    data() {
        return {
            searchform: {
                pageNum: 1,
                pageSize: 10,
                siteId: "",
                lightBoxCode: "",
                lightBoxName: "",
                lightBoxDesc: "",
                lightBoxAddress: ""
            },
            deviceform: {
                pageNum: 1,
                pageSize: 10,
                deviceNickCode: "",
                bindType: "",
                lightBoxId: ""
            },
            siteInfo: {},
            tableData: [],
            devicesData: [],
            planIdData: [],
            total: 0,
            devicetotal: 0,
            loading: true,
            selectionRows: [],
            selectfield: "lightBoxCode",
            deviceselectfield: "deviceNickCode",
            keyword: "",
            devicekeyword: "",
            isFormLightbox: true,
            dialogVisible: false
        }
    },
    methods: {
        onSubmit() {
            this.searchform.lightBoxCode = "";
            this.searchform.lightBoxName = "";
            this.searchform.lightBoxDesc = "";
            this.searchform.lightBoxAddress = "";
            this.searchform.pageNum = 1;
            this.searchform[this.selectfield] = this.keyword.trim();
            this.$route.meta.lightBoxData = this.searchform;
            this.initData();
        },
        onSubmitDevice() {
            this.searchform.deviceNickCode = "";
            this.deviceform[this.deviceselectfield] = this.devicekeyword.trim();
            this.initNolightbox();
        },
        handleSizeChange(val) {
            this.searchform.pageSize = val;
            this.initData();
        },
        dhandleSizeChange(val) {
            this.deviceform.pageSize = val;
            this.initNolightbox();
        },
        handleCurrentChange(val) {
            this.searchform.pageNum = val;
            this.initData();
        },
        dhandleCurrentChange(val) {
            this.deviceform.pageNum = val;
            this.initNolightbox();
        },
        returnMForm() {
            this.$router.push({ path: '/site/customsite' });
        },
        Rowview(val) {
            this.$route.meta.row = val;
            this.$router.push({ path: '/lightbox/info/view/' + val.lightBoxId });
        },
        RowEdit(val) {
            this.$route.meta.row = val;
            this.$router.push({ path: '/lightbox/info/edit/' + val.lightBoxId });
        },
        Rowdelete(val) {
            this.$confirm("确定要删除 '" + val.lightBoxCode + "' 此记录么？", "删除提示", { type: "warning" })
                .then(() => {
                    var Vuethis = this;
                    this.$hrraxios({
                            method: "delete",
                            url: this.$api.lightbox.DelLightbox + "/" + val.lightBoxId
                        })
                        .then((response) => {
                            var redata = response.data;
                            if (redata.Success == true) {
                                Vuethis.$message({ message: "删除成功！", type: "success" });
                                Vuethis.initData();
                            } else {
                                Vuethis.$message({ message: redata.Prompt, type: "error" });
                            }
                        })
                }).catch((error) => {
                    console.log(error);
                });
        },
        RowSetDevcie(val) {
            this.$confirm("确定要将 '" + val.deviceNickCode + "' 此设备替换上媒体么？", "替换提示", { type: "warning" })
                .then(() => {
                    var Vuethis = this;
                    this.$hrraxios.get(this.$api.device.updatelightboxdevice, {
                            params: {
                                lightboxid: this.deviceform.lightBoxId,
                                deviceid: val.deviceId,
                            }
                        })
                        .then((response) => {
                            var redata = response.data;
                            if (redata.Success == true) {
                                Vuethis.$message({ message: "替换成功！", type: "success" });
                                Vuethis.dialogVisible = false;
                            } else {
                                Vuethis.$message({ message: redata.Prompt, type: "error" });
                            }
                        })
                }).catch((error) => {
                    console.log(error);
                });
        },
        RowDevice(val) {
            this.$store.commit('setlightboxInfo', val);
            this.$router.push({ path: '/site/customdevice' + "/" + val.lightBoxId });
        },
        RowChange(val) {
            this.deviceform.lightBoxId = val.lightBoxId;
            this.initNolightbox();
            this.dialogVisible = true;
        },
        Addclick() {
            this.$router.push({ path: '/lightbox/info/add/', });
        },
        handleClick(tab, event) {
            console.log(tab, event);
        },
        cellStyle(row,column,rowIndex,columnIndex){
            if(row.column.label==="使用设备数"){
                return 'font-weight: bolder;color:#ff9c70;text-align:center'
            }
        },
        pubclick() {
            if (this.selectionRows.length == 0) {
                this.$message({ message: "请先选择一行在操作", type: "warning" });
                return;
            }
        },
        editclick() {
            if (this.selectionRows.length == 0) {
                this.$message({ message: "请先选择一行在操作", type: "warning" });
                return;
            }
            if (this.selectionRows.length > 1) {
                this.$message({ message: "只能操作一行数据", type: "warning" });
                return;
            }
            this.$route.meta.row = this.selectionRows[0];
            this.$router.push({ path: '/lightbox/info/edit/' + this.selectionRows[0].lightBoxId });
        },
        delclick() {
            if (this.selectionRows.length < 1) {
                this.$message({ message: "请先选择一行在删除", type: "warning" });
                return;
            }
            this.$confirm("确定要删除这些记录么？", { type: "warning" })
                .then(() => {
                    var loading = this.$loading({
                        lock: true,
                        text: '删除中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var Vuethis = this;
                    var PostfunArr = [];
                    this.selectionRows.forEach(myrow => {
                        var postRe = this.$hrraxios({
                            method: "delete",
                            url: this.$api.lightbox.DelLightbox + "/" + myrow.lightBoxId
                        })
                        PostfunArr.push(postRe);
                    });
                    this.$axios.all(PostfunArr)
                        .then(this.$axios.spread(function() {
                            loading.close();
                            //console.log(arguments);
                            var isalldel = true;
                            for (var i = 0; i < arguments.length; i++) {
                                if (arguments[i].data.Success == false) {
                                    isalldel = false;
                                }
                            }
                            if (isalldel == true) {
                                Vuethis.$message({ message: "全部删除成功！", type: "success" });
                                Vuethis.initData();
                            } else {
                                //有删除失败的未处理
                            }
                        }));
                })
                .catch((error) => {

                });
        },
        cellclick(row, column, cell, event) {
            this.$refs.Opentable.toggleRowSelection(row);
        },
        selectionchange(selection) {
            this.selectionRows = selection;
        },
        initData() {
            var Vuethis = this;
            this.loading = true;
            this.searchform.siteId = this.$route.params.id;
            this.$hrraxios.get(this.$api.lightbox.getLightbox, { params: this.searchform })
                .then(function(response) {
                    Vuethis.loading = false;
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.tableData = data.Data.List;
                        Vuethis.total = data.Data.Total;
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    Vuethis.loading = false;
                    console.log(error);
                });
        },
        initNolightbox() {
            var Vuethis = this;
            this.loading = true;
            this.$hrraxios.post(this.$api.device.getdevicebynolightbox, this.deviceform)
                .then(function(response) {
                    Vuethis.loading = false;
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.devicesData = data.Data.List;
                        Vuethis.devicetotal = data.Data.Total;
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    Vuethis.loading = false;
                    console.log(error);
                });
        }
    },
    beforeRouteLeave(to, from, next) {
        // 导航离开该组件的对应路由时调用
        to.meta.row = from.meta.row;
        next();
    },
    created() {
        //功能管理
        this.$store.commit('getsiteInfo');
        this.siteInfo = this.$store.state.siteInfo;
        this.$common.getFunListByMCode(this, "CustomSite", () => {
            this.initData();
        });
    }
}
</script>
<style>
.input-with-select {
    width: 110px;
}

.educard label {
    color: #99a9bf;
}

.educard {
    margin-bottom: 10px;
}

.utable .el-button,
.utable .el-button+.el-button {
    margin-right: 10px;
    margin-left: 0;
}

.el-dialog-change .el-dialog {
    width: 51%;
}

#customlightbox .lightbox-from .el-form-item__label {
    font-size: 14px !important;
    font-weight: bold;
    color: #4a65fb;
}

#customlightbox .lightbox-from .el-form-item__content {
    font-size: 14px !important;
}

#customlightbox .lightbox-from .el-form-item {
    margin-bottom: 0;
}
</style>